import { createGlobalStyle } from 'styled-components';

export const CanvasDataGridContextMenu = createGlobalStyle`
    body .canvas-datagrid-context-menu {
      background: #fff !important;
      padding: 8px 5px !important;
      border-width: 0 !important;
      border-radius: 4px !important;
      box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0;

      & > div > div {
        margin: 2px 2px 6px 2px;
        
        input {
          height: 22px !important;
          border-radius: 4px !important;
          border-color: #ced4da !important;
        }
        button {
          width: 22px !important;
          height: 22px !important;
          background: #fafafa !important;
        }
      }

      .canvas-datagrid-context-menu-item {
      }
    }
`;
